import React from "react";
import { useRouter } from "next/router";
import { FormButton } from "@/lib/styles";
import { Center, Title, Subtitle } from "./styles";

type Props = {
  title: string;
  subTitle: string;
  buttonText: string;
  redirectTo: string;
};

export default function InformationModule(props: Props) {
  const { title, subTitle, buttonText, redirectTo } = props;
  const router = useRouter();

  return (
    <Center>
      <Title as="h1">{title}</Title>
      <Subtitle>{subTitle}</Subtitle>
      <FormButton onClick={() => router.push(redirectTo)}>
        {buttonText}
      </FormButton>
    </Center>
  );
}
